/**
 * @constructor
 * @param {SpinReels} spinReels
 * @returns {ReelsSpinner}
 */
export function ReelsSpinner(spinReels) {
	this._spinReels = spinReels;

	this._onStart = function() {};
	/** @param {SpinReel} reel */
    this._onStop = function(reel) {};

	/** @param {SpinReel} reel */
	this._onBrakeDown = function(reel) {};

	/** @param {SpinReel} reel */
	this._onBrakeUp = function(reel) {};

	this._onComplete = function() {};
}

/**
 * @returns {Promise}
 */
ReelsSpinner.prototype.spin = function() {
	var _self = this;

	this._onStart();

	var allStopped = [];

	for(var i = 0; i < this._spinReels.getReels().length; i++) {

        //console.time('r' + i);

		var reel = this._spinReels.getReel(i);
		reel.motion.reinitSpeed();
		reel.reviveSpinSymbols();

		reel.setTmpSymbols();
		reel.initTmpSymbols();
		reel.clearResSymbols();
		reel.reinitPositions();

		(function(reel) {
			reel.onSpin(function() {
				reel.createBlurTmpSymbols(_self._spinReels.symbolsGroup);
				reel.showInvisibleSymbols();
			});

			reel.onBrakeDown(function() {

				_self._onBrakeDown(reel);

				reel.removeHidedSymbols();
				reel.createSymbols();
			});

			reel.onBrakeUp(function() {
				_self._onBrakeUp(reel);
			});

			reel.onStop(function() {
				reel.removeTmpSymbols();
                _self._onStop(reel);
			});
		}(reel));

		var running = reel.start();
		allStopped.push(running);
	}

	this._spinReels.startSpinReels();

	return Promise.all(allStopped).then(function() {

		_self._spinReels.stopSpinReels();
		_self._spinReels.reinitSpreaded();

		for(var i = 0; i < _self._spinReels.getReels().length; i++) {
			var reel = _self._spinReels.getReel(i);
			reel.killSpinSymbols();

			reel.storm && reel.storm.stop();
			reel.storm = null;
		}

		_self._onComplete();
	});
};

ReelsSpinner.prototype.setOnComplete = function(func) {
	this._onComplete = func;
};

ReelsSpinner.prototype.setOnStop = function(func) {
	this._onStop = func;
};

ReelsSpinner.prototype.setOnBrakeDown = function(func) {
	this._onBrakeDown = func;
};

ReelsSpinner.prototype.setOnBrakeUp = function(func) {
	this._onBrakeUp = func;
};

ReelsSpinner.prototype.setOnStart = function(func) {
	this._onStart = func;
};